module.exports = __webpack_public_path__ + "static/img/shui.6014242.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shui.png
// module id = Asmf
// module chunks = 0